import React from "react";

import videoBg from "../assets/img/footer.webp";
// import { VideoPlayer } from "./VideoPlayer";
import axios from "axios";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed, dynamicSuccess } from "../hooks/custom/useToast";

export const Video = () => {
  const { setLoading } = useLoader();

  const [subscribeEmail, setSubscribeEmail] = React.useState("");

  const isValidEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!isValidEmail(subscribeEmail)) {
      dynamicFailed("Please enter a valid email address!");
      return;
    }

    setLoading(true);

    const data = {
      email: subscribeEmail,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/subscribe`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSubscribeEmail("");
        dynamicSuccess("Subscribed successfully!");
        setLoading(false);
      } else {
        dynamicFailed("Subscription failed!");
        setLoading(false);
      }
    } catch (error: any) {
      dynamicFailed("Subscription failed!");
      setLoading(false);
    }
  };

  return (
    <section style={{ backgroundColor: "#2f2b75" }}>
      <div
        className="td_video_block td_style_1 td_accent_bg td_bg_filed td_center text-center"
        style={{ backgroundImage: `url(${videoBg})` }}
      >
        <div className="container">
          {/* <VideoPlayer
            trigger={
              <a
                href="#vid2"
                className="td_player_btn_wrap_2 td_video_open wow zoomIn"
                data-wow-duration="1s"
                data-wow-delay="0.2s"
              >
                <span className="td_player_btn td_center">
                  <span></span>
                </span>
              </a>
            }
          /> */}

          <div className="td_height_70 td_height_lg_50" />
          {/* <h2
            className="td_fs_48 td_white_color mb-0 wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            Take a Video Tour to Learn <br />
            More About University of Nepal
          </h2> */}
        </div>
      </div>
      <div
        className="container wow fadeInUp"
        data-wow-duration="1s"
        data-wow-delay="0.25s"
      >
        <div className="td_contact_box td_style_1 td_white_bg td_radius_10">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3 className="td_fs_36 mb-0 td_accent_color">
              <h2>Subscribe Now</h2>
            </h3>
            <p className="td_fs_18 td_light td_accent_color td_mb_20 text-center">
              Be the first to hear about new programs, campus developments,
              events, and ways to get involved as we build Nepal’s next great
              university.
            </p>
            <div className="td_footer_col">
              <div className="td_footer_widget">
                <div
                  className="td_newsletter td_style_1"
                  style={{ marginBottom: "5px" }}
                >
                  <form className="td_newsletter_form">
                    <input
                      type="email"
                      className="td_newsletter_input"
                      placeholder="Email address"
                      value={subscribeEmail}
                      onChange={(e) => setSubscribeEmail(e.target.value)}
                      style={{ width: "60dvw" }}
                    />
                    <button
                      onClick={handleSubscribe}
                      className="td_btn td_style_1 td_radius_30 custom-td_style_1 td_medium bg-transparent"
                    >
                      <span className="td_btn_in custom_td_btn_in">
                        <span>Subscribe</span>
                      </span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
